import type { Component } from 'vue';
import Switch from './Switch.vue';
import Switcher from './Switcher.vue';

export default new Map<string, Component>([
  ['Switch', Switch],
  ['Switcher', Switcher],
]);

